// sponsorsData.js - Centralized management of sponsor information

// Sponsor tiers (simplified to a single tier for all sponsors)
export const SPONSOR_TIERS = {
    SUPPORTER: {
      name: 'supporter',
      displayName: 'Sponsors',
      priority: 1,
      maxHeight: 32,
      mobileHeight: 28,
      smallScreenHeight: 24
    }
  };
    
  // List of sponsors (all sponsors now use the same tier)
  const sponsorsData = [
    {
      id: 'estrella',
      name: 'Estrella',
      logo: '/remejai/estrella.png', // Replace with actual logo path
      url: 'https://estrella.lt',
      tier: SPONSOR_TIERS.SUPPORTER.name
    },
    
    {
      id: 'iconfit',
      name: 'IconFit',
      logo: '/remejai/iconfit.png', // Replace with actual logo path
      url: 'https://iconfit.lt',
      tier: SPONSOR_TIERS.SUPPORTER.name
    },
    {
      id: 'gubernija',
      name: 'Gubernija',
      logo: '/remejai/gubernija.png', // Replace with actual logo path
      url: 'https://gubernija.lt',
      tier: SPONSOR_TIERS.SUPPORTER.name
    },
    
    {
      id: 'ecosh',
      name: 'Ecosh',
      logo: '/remejai/ecosh.png', // Replace with actual logo path
      url: 'https://ecosh.lt',
      tier: SPONSOR_TIERS.SUPPORTER.name
    },
    {
      id: 'sapiens',
      name: 'Sapiens',
      logo: '/remejai/sapiens.png', // Replace with actual logo path
      url: 'https://sapiens.lt',
      tier: SPONSOR_TIERS.SUPPORTER.name
    },
    {
      id: 'vitabiotics',
      name: 'Vitabiotics',
      logo: '/remejai/vitabiotics.jpg', // Replace with actual logo path
      url: 'https://vitabiotics.lt',
      tier: SPONSOR_TIERS.SUPPORTER.name
    },
    {
        id: 'smelioarena',
        name: 'Smėlio Arena',
        logo: '/remejai/smelioarena.png', // Replace with actual logo path
        url: 'https://smelioarena.lt',
        tier: SPONSOR_TIERS.SUPPORTER.name
      },
    
    {
      id: 'weinhale',
      name: 'Weinhale',
      logo: '/remejai/inhale.png', // Replace with actual logo path
      url: 'https://weinhale.com',
      tier: SPONSOR_TIERS.SUPPORTER.name
    },
    {
      id: 'ganini',
      name: 'HoheSC',
      logo: '/remejai/hc.png', // Replace with actual logo path
      url: 'https://www.hohesc.lt',
      tier: SPONSOR_TIERS.SUPPORTER.name
    },
    
    {
      id: 'biofarmacija',
      name: 'Biofarmacija',
      logo: '/remejai/biofarmacija.png', // Replace with actual logo path
      url: 'https://biofarmacija.eu',
      tier: SPONSOR_TIERS.SUPPORTER.name
    },
    {
      id: 'epbar',
      name: 'EP Bar',
      logo: '/remejai/epbar.webp', // Replace with actual logo path
      url: 'https://energijosproduktai.lt/',
      tier: SPONSOR_TIERS.SUPPORTER.name
    },
    {
      id: 'gaidelis',
      name: 'Gaidelis',
      logo: '/remejai/gaidelis.png', // Replace with actual logo path
      url: 'https://gaidelisklasika.lt/',
      tier: SPONSOR_TIERS.SUPPORTER.name
    }
  ];
    
  // Helper functions
  export const getSponsorsByTier = (tier) => {
    return sponsorsData.filter(sponsor => sponsor.tier === tier);
  };
    
  export const getAllSponsors = () => {
    // All sponsors now have the same tier, so we just return the full list
    return [...sponsorsData];
  };
    
  export default sponsorsData;